import React from 'react';

import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import styles from './FormInputField.module.scss';

const FormInputField = ({
  name,
  label,
  type = 'text',
  placeholder,
  validate,
  disabled,
  autoComplete,
  maxLength,
  required,
  valueKey,
  onChange,
  parse,
  readOnly
}) => (
  <div className={styles.formGroup}>
    {label && (
      <label htmlFor={name}>
        {label}
        {(required) && <span className={styles.required}> *</span>}
      </label>
    )}
    <Field name={name} validate={validate} parse={parse}>
      {({ input, meta }) => {
        const displayValue = valueKey && input.value ? input.value[valueKey] : input.value || '';

        const handleChange = (e) => {
          input.onChange(e);
          if (onChange) onChange(e);
        };

        return (
          <>
            <input
              {...input}
              id={name}
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              autoComplete={autoComplete}
              maxLength={maxLength}
              readOnly={readOnly}
              value={displayValue}
              onChange={handleChange}
              className={`${meta.error && meta.touched ? styles.inputError : ''}`}
            />
            {meta.error && meta.touched && (
              <div className={styles.errorMessage}>{meta.error}</div>
            )}
          </>
        );
      }}
    </Field>
  </div>
);

FormInputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  valueKey: PropTypes.string,
  onChange: PropTypes.func, // new
};

export default FormInputField;
